export function RMRLogoCard({ onClick }: { onClick: () => void }) {
    return (
        <div className="rmr-logo-card__wrapper" onClick={onClick}>
            <img 
                className="rmr-logo"
                src={process.env.PUBLIC_URL + "/rmr_logo.svg"} 
                alt="Логотип работа молодёжи Росиии"
            />
            <div className="rmr-logo-card__bottom">
                <div className="rmr-logo-card__bottom__block">
                    <ion-icon name="time"></ion-icon>
                    <span>График</span>
                </div>
                <div className="rmr-logo-card__bottom__block">
                    <span>|</span>
                </div>
                <div className="rmr-logo-card__bottom__block">
                    <ion-icon name="call"></ion-icon>
                    <span>Контакты</span>
                </div>
            </div>
        </div>
    );
};